import config from '@/config';

export const TAP_MERCHANT_ID = '23176510';

const TAP_MERCHANT_NAME = 'Evinops Hafla Ltd';

const TAP_PUBLIC_KEY = process.env.NEXT_PUBLIC_TAP_PUBLIC_KEY;

export const TAP_PAY_CURRENCY_CODE = 'AED';

const GOOGLE_PAY_API_VERSION = 2;
const GOOGLE_PAY_API_VERSION_MINOR = 0;

const GOOGLE_PAY_ALLOWED_PAYMENT_METHODS = [
  {
    type: 'CARD',
    parameters: {
      allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
      allowedCardNetworks: ['MASTERCARD', 'VISA']
    },
    tokenizationSpecification: {
      type: 'PAYMENT_GATEWAY',
      parameters: {
        gateway: 'tappayments',
        gatewayMerchantId: TAP_MERCHANT_ID
      }
    }
  }
];

const GOOGLE_PAY_TOTAL_PRICE_STATUS = 'FINAL';

// Set to the BCR2DN... ID issued by Google Pay Business Console after hafla.com passes production review
const GOOGLE_PAY_MERCHANT_ID = '';

const GOOGLE_PAY_MERCHANT_INFO = {
  merchantId: GOOGLE_PAY_MERCHANT_ID,
  merchantName: TAP_MERCHANT_NAME
};

export const GOOGLE_PAY_ENABLED =
  process.env.NEXT_PUBLIC_GOOGLE_PAY_ENABLED === 'true';

export const GOOGLE_PAY_ENVIRONMENT = config.isProduction
  ? 'PRODUCTION'
  : 'TEST';

export const GOOGLE_PAY_SCRIPT_URL = 'https://pay.google.com/gp/p/js/pay.js';

export const GOOGLE_PAY_BUTTON_PROPS = {
  buttonColor: 'white',
  buttonType: 'short'
};

export const GOOGLE_PAY_SUPPORTED_PAYMENT_CONFIG = {
  apiVersion: GOOGLE_PAY_API_VERSION,
  apiVersionMinor: GOOGLE_PAY_API_VERSION_MINOR,
  allowedPaymentMethods: GOOGLE_PAY_ALLOWED_PAYMENT_METHODS
};

export const GOOGLE_PAY_BASE_PAYMENT_DATA_REQUEST = {
  ...GOOGLE_PAY_SUPPORTED_PAYMENT_CONFIG,
  merchantInfo: GOOGLE_PAY_MERCHANT_INFO,
  transactionInfo: {
    totalPriceStatus: GOOGLE_PAY_TOTAL_PRICE_STATUS,
    currencyCode: TAP_PAY_CURRENCY_CODE
  }
};

export const APPLE_PAY_SCRIPT_URL =
  'https://tap-sdks.b-cdn.net/apple-pay/build-1.2.0/main.js';

const APPLE_PAY_ENVIRONMENT = config.isProduction
  ? 'production'
  : 'development';

export const APPLE_PAY_BASE_CONFIG = {
  debug: false,
  scope: 'TapToken',
  publicKey: TAP_PUBLIC_KEY,
  environment: APPLE_PAY_ENVIRONMENT,
  acceptance: {
    supportedBrands: ['masterCard', 'visa'],
    supportedCards: 'ALL'
  },
  features: {
    supportsCouponCode: false
  },
  interface: {
    edges: 'curved',
    locale: 'en',
    theme: 'light',
    type: 'plain'
  }
};

export const TAP_CARD_SDK_SCRIPT_URL =
  'https://tap-sdks.b-cdn.net/card/1.0.2/index.js';

export const TAP_CARD_SDK_CONTAINER_ID = 'card-sdk-id';

export const TAP_CARD_SDK_BASE_CONFIG = {
  publicKey: TAP_PUBLIC_KEY,
  merchant: {
    id: TAP_MERCHANT_ID
  },
  acceptance: {
    supportedBrands: ['VISA', 'MASTERCARD'],
    supportedCards: 'ALL'
  },
  fields: {
    cardHolder: true
  },
  addons: {
    displayPaymentBrands: false,
    loader: true,
    saveCard: true
  },
  interface: {
    direction: 'ltr',
    edges: 'curved',
    locale: 'en',
    theme: 'light'
  }
};
